import axios from "axios";
import config from "config";
import { getEventIcon } from "modules/eventIcons";

const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const API_URL = config.MAP_MATCHING_API_URL;

// -------------------------------------------------------
// Normalize geometry for mapbox (Point [[lon,lat]] → [lon,lat])
// -------------------------------------------------------
const normalizeGeometry = (geometry) => {
  if (!geometry) return null;

  if (
    geometry.type === "Point" &&
    Array.isArray(geometry.coordinates) &&
    Array.isArray(geometry.coordinates[0])
  ) {
    return {
      ...geometry,
      coordinates: geometry.coordinates[0],
    };
  }

  return geometry;
};

// -------------------------------------------------------
// Convert "Roadworks" → "roadworks" (for debugging or UI)
// -------------------------------------------------------
const normalizeIconKey = (categoryName) =>
  categoryName ? categoryName.toLowerCase().replace(/\s+/g, "-").trim() : "";

// -------------------------------------------------------
// Label used in ScenarioForm dropdowns
// -------------------------------------------------------
const formatEventLabel = (ev) => {
  const categoryName = ev.category?.name || "Event";
  const from = ev.valid_from ? new Date(ev.valid_from) : null;
  const to = ev.valid_until ? new Date(ev.valid_until) : null;

  const formatDate = (d) =>
    d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  if (!from && !to) return categoryName;

  if (from && to) {
    return `${categoryName} ${formatDate(from)} -- ${formatDate(to)}`;
  }

  if (from && !to) {
    return `${categoryName} ${formatDate(from)}`;
  }

  return categoryName;
};

// -------------------------------------------------------
// MAIN FETCH FUNCTION
// -------------------------------------------------------
export async function fetchEvents() {
  const body = { filters: ["status-2", "source-3"] };

  const response = await axios.post(`${API_URL}/filtered-events`, body, {
    headers: { "X-API-Key": API_TOKEN },
  });

  const raw = response.data || [];

  // -------------------------------------------------------
  // Normalize + enrich events for UI and map
  // -------------------------------------------------------
  const normalized = Array.isArray(raw)
    ? raw.map((ev) => {
        const geometry = normalizeGeometry(ev.geometry);
        const label = formatEventLabel(ev);
        const iconKey = normalizeIconKey(ev.category?.name);
        const icon = getEventIcon(ev.category?.id); // image used in UI lists

        return {
          // keep all original backend fields (symbolLayer needs them)
          ...ev,

          // map ready geometry
          geometry,
          linkIds: ev.link_id || [],

          // UI fields
          name: label,
          label,
          iconKey,

          // UI icon (ScenarioForm dropdown)
          icon,
          iconSrc: icon,
        };
      })
    : [];

  return normalized;
}
